module.exports = __webpack_public_path__ + "media/images/bg_5-37c1133bf79e6de23a84e8fcb288f375.jpg";